import { useRef, useState, useEffect } from 'react';
import { Select as SelectAnt } from 'antd';
import { generateUniqueClass } from 'utils';
import { SelectWrapper } from './select.styles';
import { ISelect } from './select.type';

const Select = ({ onChange, ...props }: ISelect) => {
  const [uniqueClass, setUniqueClass] = useState('');
  const [open, setOpen] = useState(true)
  const selectWrapperRef = useRef(null);

  useEffect(() => {
    setOpen(false)
    const generatedClass = generateUniqueClass();
    setUniqueClass(generatedClass);
  }, []);

  const handleChange = (event: string) => {
    setOpen(!open)
    onChange(event)
  }
  
  return (
    <SelectWrapper ref={selectWrapperRef} onClick={() => setOpen(!open)} className={uniqueClass + " select-wrapper"}>
      <SelectAnt
        {...props}
        open={open}
        onDropdownVisibleChange={() => setOpen(false)}
        onChange={handleChange}
        popupClassName="select"
        getPopupContainer={() => {
          return selectWrapperRef.current || document.body;
        }}
      />
    </SelectWrapper>
  );
};

export default Select;
